module.exports = __webpack_public_path__ + "static/media/digital_guide_book.af399f7d.png";